import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MakePaymentMethodDefaultRequestDTO } from 'features/settings/dtos/make-payment-method-default-request.dto';
import { SettingsService } from 'features/settings/settings.service';
import { Icon } from 'shared/components/particles/icon/icon';
import { PaymentMethod } from 'shared/models/settings/payment-method';
import { CurrencyFormatPipe } from 'shared/pipes/currency-format.pipe';

export interface ChangePlanConfirmationDialogData {
  title: string;
  price: number;
  per: string;
  users: number;
  location: number;
  detail: string[];
}

@Component({
  selector: 'app-change-plan-confirmation',
  imports: [CommonModule, FormsModule, TranslateModule, Icon, CurrencyFormatPipe],
  providers: [SettingsService],
  templateUrl: './change-plan-confirmation.html',
  styleUrl: './change-plan-confirmation.scss',
})
export class ChangePlanConfirmation implements OnInit {
  paymentMethods: PaymentMethod[] = [];
  selectedPaymentMethodId: string = '';

  constructor(
    private dialogRef: MatDialogRef<ChangePlanConfirmation>,
    @Inject(MAT_DIALOG_DATA) public data: ChangePlanConfirmationDialogData,
    private settingsService: SettingsService,
    private cdr: ChangeDetectorRef
  ) {}

  onClose(isConfirmed: boolean = false) {
    this.dialogRef.close({ isConfirmed });
  }

  onConfirm() {
    if (this.selectedPaymentMethodId === this.defaultPaymentMethod?.id) {
      this.onClose(true);
    } else {
      this.makePaymentMethodDefault();
    }
  }

  getPaymentMethods() {
    this.settingsService.getPaymentMethods().subscribe({
      next: (resp) => {
        const { isSuccess = false, data } = resp;
        if (isSuccess) {
          this.paymentMethods = data;
          this.selectedPaymentMethodId = this.defaultPaymentMethod?.id as string;
          this.cdr.detectChanges();
        }
      }
    })
  }

  makePaymentMethodDefault() {
    const body = new MakePaymentMethodDefaultRequestDTO({ paymentMethodId: this.selectedPaymentMethodId as string });
    this.settingsService.makePaymentMethodDefault(body).subscribe({
      next: (resp) => {
        const { isSuccess = false } = resp;
        if (isSuccess) {
          this.onClose(true);
        }
      }
    })
  }

  get defaultPaymentMethod() {
    return this.paymentMethods.find(method => method.isDefault);
  }

  ngOnInit(): void {
    this.getPaymentMethods();
  }
}
